import { gql } from '@apollo/client'

export const Query = gql`
  query Attachments(
    $companyId: ID!,
    $filters: AttachmentFilters!,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    attachments(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        filename
        url
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
